import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const LocationPin = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='LocationPin' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,10 C14.209139,10 16,8.209139 16,6 C16,3.790861 14.209139,2 12,2 C9.790861,2 8,3.790861 8,6 C8,8.209139 9.790861,10 12,10 Z M12,10 L12,22' />
  </StyledIcon>
);
